import { measureNodesScreenSpace } from "frontend/utils/node-utils";
import style from "../../../../elements-toolbar/elements-toolbar.module.css";
import classNames from "classnames";
import BoundingBox from "frontend/geometry/bounding-box";
import * as icons from "frontend/icons/icons";
import { DropdownButton } from "../../../../elements-toolbar/toolbar-buttons";
import { ConvertToMondayItemPopup } from "./convert-menu";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";
import Konva from "konva";
import { useRef } from "react";
import { useHover } from "usehooks-ts";

export function ConvertToMondayItemButton({
  nodes,
  onConvertToMondayItem,
  enabled,
  tooltip,
}: {
  nodes: Konva.Node[];
  onConvertToMondayItem?: (itemType: "item" | "subitem", nodes: Konva.Node[], anchor: DOMRect) => void; // TODO: Remove in the future in favor of context.
  enabled?: boolean;
  tooltip?: string | null;
}) {
  const disabledRef = useRef<HTMLDivElement>(null);
  const disabledHover = useHover(disabledRef);

  if (!enabled) {
    return (
      <div className={style.row}>
        <div
          className={classNames(style.disabledConvertButton)}
          data-testid="convertToMondayButtonDisabled"
          ref={disabledRef}
        >
          <icons.MondayLogo size={22} color="#657e9a" />
          <span>Convert</span>
        </div>
        {disabledHover && tooltip && (
          <Tooltip
            label={tooltip}
            relativeTo={disabledRef}
            side="top"
            customStyle={{ borderRadius: "6px", fontSize: "10px" }}
            margin={10}
            arrowSize={8}
          />
        )}
      </div>
    );
  }

  return (
    <div className={style.row}>
      <DropdownButton
        id="convert_to_monday_item_button"
        data-testid="convertToMondayButton"
        tooltip="Convert to monday item"
        hideArrow
        renderPopup={(closePopup) => {
          if (!onConvertToMondayItem) {
            return null;
          }

          return (
            <ConvertToMondayItemPopup
              onConvertToMondayItem={(itemType) => {
                const bbox = BoundingBox.expandOnAll(measureNodesScreenSpace(nodes, { skipStroke: true }));
                const anchor = new DOMRect(bbox.x, bbox.y, bbox.width, bbox.height);
                onConvertToMondayItem(itemType, nodes, anchor);
              }}
              closePopup={closePopup}
            />
          );
        }}
      >
        <div className={style.convertToMondayButtonContent}>
          <icons.MondayLogo size={22} />
          <span>Convert</span>
        </div>
      </DropdownButton>
    </div>
  );
}
